var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIconMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.645,
    y: 13.4061,
    width: 14.6055,
    height: 20.9488,
    rx: 5.655,
    stroke: "#979EA8",
    strokeWidth: 1.29
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7505,
    y: 0.645,
    width: 14.6055,
    height: 20.9488,
    rx: 5.655,
    stroke: "#979EA8",
    strokeWidth: 1.29
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7505,
    y: 24.5254,
    width: 14.6055,
    height: 9.8294,
    rx: 4.9147,
    stroke: "#979EA8",
    strokeWidth: 1.29
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.645,
    y: 0.645,
    width: 14.6055,
    height: 9.8294,
    rx: 4.9147,
    stroke: "#979EA8",
    strokeWidth: 1.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconMenu);
export default __webpack_public_path__ + "static/media/DashboardIcon_menu.d6904d36b2dbb130eef70688df2f3fa6.svg";
export { ForwardRef as ReactComponent };